/* eslint-disable react/prop-types */
import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Chip,
  Button,
  Divider,
} from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

const InfoRow = ({ label, value }) => (
  <Grid container style={{ marginBottom: 10 }}>
    <Grid item xs={4} sm={3}>
      <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>{label}</Typography>
    </Grid>
    <Grid item xs={8} sm={9}>
      <Typography style={{ fontSize: 14 }}>{value || "N/A"}</Typography>
    </Grid>
  </Grid>
);

const ViewCoursePurchase = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { purchase, userId } = state || {};
  const course = purchase?.course || {};

  if (!purchase) {
    return (
      <Container maxWidth={false} disableGutters style={{ margin: "0 2%" }}>
        <Typography>No course purchase data found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} disableGutters style={{ margin: "0 2%", minHeight: "70vh" }}>
      {/* Breadcrumb */}
      <Typography style={{ fontWeight: "bold", display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <Link to="/admin/user" style={{ color: "black", textDecoration: "none", marginRight: 4 }}>Users</Link>
        &gt;
        <span
          style={{ cursor: "pointer", marginLeft: 4, marginRight: 4 }}
          onClick={() => navigate("/admin/user/view-user", { state: { id: userId } })}
        >
          View User
        </span>
        &gt;
        <span style={{ fontWeight: "bold", marginLeft: 4 }}>Course Purchase Detail</span>
      </Typography>

      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
        variant="outlined"
        size="small"
      >
        Back
      </Button>

      {/* Purchase Info */}
      <Box style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.1)", marginBottom: 16 }}>
        <Typography variant="h6" style={{ fontWeight: 700, marginBottom: 16 }}>
          Purchase Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InfoRow label="Purchase ID" value={purchase.id} />
            <InfoRow label="Price" value={purchase.price !== null && purchase.price !== undefined ? `INR ${purchase.price}` : null} />
            <InfoRow
              label="Purchased At"
              value={purchase.createdAt ? moment(purchase.createdAt).format("DD/MM/YYYY HH:mm") : null}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Course Info */}
      <Box style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.1)" }}>
        <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            {course.name || "Course Detail"}
          </Typography>
          <Chip
            label={course.isActive ? "Active" : "Inactive"}
            size="small"
            style={{
              background: course.isActive ? "#e8f5e9" : "#ffebee",
              color: course.isActive ? "#2e7d32" : "#c62828",
              fontWeight: 600,
            }}
          />
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={course.image?.url ? 8 : 12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <InfoRow label="Name" value={course.name} />
                <InfoRow label="Type" value={course.type} />
                <InfoRow label="Tag" value={course.tag} />
                <InfoRow
                  label="Created At"
                  value={course.createdAt ? moment(course.createdAt).format("DD/MM/YYYY HH:mm") : null}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 4 }}>
                  Description
                </Typography>
                <Typography style={{ fontSize: 14 }}>
                  {course.description || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {course.image?.url && (
            <Grid item xs={12} md={4}>
              <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 8 }}>
                Course Image
              </Typography>
              <img
                src={course.image.url}
                alt={course.image.name || "course-image"}
                style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 8, border: "1px solid #eee" }}
              />
            </Grid>
          )}
        </Grid>

        {/* Videos */}
        {Array.isArray(course.videos) && course.videos.length > 0 && (
          <Box style={{ marginTop: 24 }}>
            <Divider style={{ marginBottom: 16 }} />
            <Typography style={{ fontWeight: 700, marginBottom: 12 }}>
              Videos ({course.videos.length})
            </Typography>
            <Grid container spacing={2}>
              {course.videos.map((video, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Box style={{ background: "#f9f9f9", borderRadius: 8, padding: 12 }}>
                    {video.thumbnailUrl && (
                      <img
                        src={video.thumbnailUrl}
                        alt={video.title || `video-${i}`}
                        style={{ width: "100%", height: 100, objectFit: "cover", borderRadius: 6, marginBottom: 8 }}
                      />
                    )}
                    <Typography style={{ fontWeight: 600, fontSize: 13 }}>
                      {video.title || `Video ${i + 1}`}
                    </Typography>
                    {video.duration && (
                      <Typography style={{ fontSize: 12, color: "#888" }}>
                        Duration: {video.duration}s
                      </Typography>
                    )}
                    {video.description && (
                      <Typography style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
                        {video.description}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default ViewCoursePurchase;
